import { render, staticRenderFns } from "./important-links-section.vue?vue&type=template&id=7caa85d8&scoped=true"
import script from "./important-links-section.vue?vue&type=script&lang=ts"
export * from "./important-links-section.vue?vue&type=script&lang=ts"
import style0 from "./important-links-section.vue?vue&type=style&index=0&id=7caa85d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7caa85d8",
  null
  
)

export default component.exports